import { makeStyles } from 'tss-react/mui';

export const useWrapper = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
  },
});

export const useShakeStyles = makeStyles()(() => ({
  '@global': {
    '@keyframes shake': {
      '0%, 90%': {
        transform: 'translate(-1px, 0)',
      },
      '20%, 80%': {
        transform: 'translate(2px, 0)',
      },
      '30%, 50%, 70%': {
        transform: 'translate(-4px, 0)',
      },
      '40%, 60%': {
        transform: 'translate(4px, 0)',
      },
    },
  },
  runShake: {
    animation: 'shake 820ms cubic-bezier(.36, .07, .19, .97) both',
  },
}));
